export default __webpack_public_path__ + "static/media/start-rev.91e31c25.svg";